// Business Portal Shell
// ────────────────────────────────────────────────────────────────────
// Wraps every /business route so portal-wide notices render once and stay
// put as the merchant moves between the dashboard, settings, hours, and
// analytics. Without a shared shell a banner mounted on the dashboard
// disappears the moment they navigate to fix the thing it warned about.

import type { ReactNode } from 'react';
import { PayoutHoldBanner } from './PayoutHoldBanner';

export function BusinessLayout({ children }: { children: ReactNode }) {
  return (
    <>
      <PayoutHoldBanner />
      {children}
    </>
  );
}
